import React from "react";

import asIcon from "./asIcon";

export default asIcon(({ color }) => <path fill={color} d="M50 16.7l-28.9 50h57.8z" />);
